var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',{attrs:{"id":"black-screen-loader"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }